export const MERCHANT_UPDATED_EVENT = 'merchant-updated';

export const notifyMerchantUpdated = () => {
  window.dispatchEvent(new Event(MERCHANT_UPDATED_EVENT));
};
